module.exports = __webpack_public_path__ + "img/radio3.66538c07.png";